import React, { ReactNode, useState } from "react";
import { clsx } from 'clsx';
import './Collapsible.scss';

type CollapsibleProps = {
    title: string,
    openIcon?: string,
    closeIcon?: string,
    titleClass?: string,
    contentClass?: string,
    iconPosition?: string,
    children: ReactNode,
    active?: boolean,
    disabled?: boolean,
    desktopDisabled?: boolean,
    mobileDisabled?: boolean,
    nested?: boolean,
    rotateIcon?: boolean,
    tier?: 1 | 2 | undefined
};

export function Collapsible(props: CollapsibleProps) {
    // console.log('props', props)
  const {
    title,
    active = false,
    openIcon = 'icon-at-plus',
    closeIcon = 'icon-at-minus',
    titleClass = 'b2',
    contentClass = 'b2',
    iconPosition,
    children,
    disabled = false,
    desktopDisabled = false,
    mobileDisabled = false,
    nested = false,
    rotateIcon,
    tier = null
  } = props;

  const [isActive, setIsActive] = useState(active);

  function toggle() {
    if (disabled) return;

    setIsActive(!isActive);
  }

  return (
      <div
          className={clsx({
              'collapsible': true,
              'collapsible--active-nested-1': tier == 1 && isActive,
              'collapsible--disabled-nested-1': tier == 1 && disabled,
              'collapsible--active-nested-2': tier == 2 && isActive,
              'collapsible--disabled-nested-2': tier == 2 && disabled,
              'collapsible--active': !tier && isActive,
              'collapsible--disabled': !tier && disabled,
              'collapsible--desktop-disabled': desktopDisabled,
              'collapsible--mobile-disabled': mobileDisabled
          })}
      >
          <div
              className={`collapsible__title ${titleClass}`}
              onClick={() => toggle()}
          >

            <div className={'collapsible__title-wrapper'}>
              {isActive && iconPosition === 'left' &&
                <span className={'collapsible__left-icon ' + openIcon}></span>
              }

              {title}
            </div>

              {!disabled && !tier && iconPosition !== 'left' &&
                  <>
                    {!rotateIcon ? (
                      <>
                        <span className={'collapsible__expand-icon ' + openIcon}></span>
                        <span className={'collapsible__collapse-icon ' + closeIcon}></span>
                      </>
                    ) : (
                      <span className={`${openIcon} collapsible__multi-icon transition-transform duration-200 origin-center ${
                        isActive ? "rotate-90" : "rotate-0"
                      }`}></span>
                    )}
                  </>
              }
              {!disabled && tier == 1 && iconPosition !== 'left' &&
                  <>
                      <span className={'collapsible__expand-icon-nested-1 ' + openIcon}></span>
                      <span className={'collapsible__collapse-icon-nested-1 ' + closeIcon}></span>
                  </>
              }
              {!disabled && tier == 2 && iconPosition !== 'left' &&
                  <>
                      <span className={'collapsible__expand-icon-nested-2 ' + openIcon}></span>
                      <span className={'collapsible__collapse-icon-nested-2 ' + closeIcon}></span>
                  </>
              }
          </div>

          <div className={clsx({
              [`collapsible__content ${contentClass}`]: !tier,
              'collapsible__content-nested-1': tier == 1,
              'collapsible__content-nested-2': tier == 2,
          })}>
              {children}
          </div>
      </div>
  )
};